import React from 'react';

function FeaturedCollectionLoading() {
  return (
    <section className="featured-collection skeleton-loader">
      <div className="feature-collection-card-v2 skeleton-loader">
        <div className="feature-collection-v2-content">
          <div className="feature-collection-v2-img bg-n-700 skeleton" />
          <div className="feature-collection-v2-text">
            <div className="heading skeleton" />
            <div className="description skeleton" />
            <div className="feature-collection-meta">
              <div className="date skeleton" />
              <div className="meta-separator skeleton" />
              <div className="date skeleton" />
            </div>
            <div className="slider-button">
              <div className="button skeleton" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedCollectionLoading;
